export default class OperatorService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/brands/' + id, params)
	}

	createEntity(params){
		return this.apiService.callPost('me/brands', params);
	}

	getEntities(params) {
		return this.apiService.callGet('me/brands', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/brands/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/brands/' + id, params)
	}

	// SEARCH
	searchBrandsForRecipients(params) {
		return this.apiService.callGet('brands_search', params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('me/brands/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BrandService.js